// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__179YB","colCheckbox":"styles_colCheckbox__2eJXe"};